import { useEffect } from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import '../../styles/TimeLimitedPopup.css';

function TimeLimitedPopup({ 
    isVisible, 
    onClose, 
    duration = 4000,
    type = 'success', // 'success', 'error', 'warning', 'info'
    title,
    message,
    subMessage
}) {
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose, duration]);

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <FaCheckCircle />;
            case 'error':
                return <FaTimes />;
            case 'warning':
                return <FaExclamationTriangle />;
            case 'info':
                return <FaInfoCircle />;
            default:
                return <FaCheckCircle />;
        }
    };

    if (!isVisible) return null;

    return (
        <div className="time-limited-popup-overlay">
            <div className="time-limited-popup-content">
                <div className={`time-limited-popup-icon ${type}`}>
                    {getIcon()}
                </div>
                <h3>{title}</h3>
                <p>{message}</p>
                {subMessage && <p className="time-limited-popup-sub">{subMessage}</p>}
                <div className="time-limited-popup-progress">
                    <div 
                        className={`time-limited-popup-progress-bar ${type}`}
                        style={{
                            animation: `timeLimitedPopupProgress ${duration}ms linear forwards`
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
}

export default TimeLimitedPopup;